import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class PreApproveRiskModel {
    riskModelPfSlugId = 'pre-approve';
    riskModelPmSlugId = 'pre-approve-pm';


    versionId = "latest";
    riskModelId = "2";

    async test(riskModelName, riskModelVersion, payload) {
        let response = await axios.post(
            `${RiskModel.endpoint}/${riskModelName}?version=${riskModelVersion}`,
            {
                version: riskModelVersion,
                schema: payload
            }
        )

        return response.data;
    }

    async run(payload) {
        let uri = payload.cdc_resume.type === "personal" ? "pre-approve" : "pre-approve/pm";
        let response = await axios.post(
            `${RiskModel.endpoint}/${uri}/${this.versionId}`,
            payload
        )

        return response.data;
    }

    /**
     * @param {Number} projectId
     * @param {String} rfc
     * @param {Boolean} isPf
     * @return {Promise<*>}
     */
    async find(projectId, rfc, isPf= true) {
        let RiskModelName = this.riskModelPfSlugId;
        if(isPf !== true) {
            let RiskModelName = this.riskModelPmSlugId;
        }

        let response = await axios.get(`${RiskModel.endpoint}/${RiskModelName}/${this.versionId}?project_id=${projectId}&rfc=${rfc}`)
        return response.data;
    }

    async history(projectId, rfc) {
        let response = await axios.get(`${RiskModel.endpoint}/pre-approve/history/${this.riskModelId}?filters[project_id]=${projectId}&filters[rfc]=${rfc}`)
        return response.data;
    }
}
